// extracted by mini-css-extract-plugin
export default {"container":"ClientsAnalytics_container__GhC9v","filterRow":"ClientsAnalytics_filterRow__zLsb-","filterLabel":"ClientsAnalytics_filterLabel__L2H4x"};